import script from "./InputDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./InputDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./InputDatePicker.vue?vue&type=style&index=0&id=e580dc68&lang=css"

const __exports__ = script;

export default __exports__